import { jsx as x } from "react/jsx-runtime";
import { c as b } from "../../vendor-CwFtm_qv.js";
import { forwardRef as h, useState as v, useEffect as S } from "react";
import { getSpacingClasses as C } from "../../utils/getSpacingClasses/index.js";
import { omit as y } from "../../utils/omit/index.js";
import { loadIcon as N } from "./loadIcon/index.js";
import '../../assets/index8.css';const j = "IAzkAq_baseIcon", w = "IAzkAq_blue", B = "IAzkAq_cactus", E = "IAzkAq_color", F = "IAzkAq_gold", H = "IAzkAq_green", L = "IAzkAq_lg", M = "IAzkAq_magenta", R = "IAzkAq_md", T = "IAzkAq_moon", $ = "IAzkAq_purple", D = "IAzkAq_red", G = "IAzkAq_sienna", J = "IAzkAq_sm", K = "IAzkAq_teal", O = "IAzkAq_xl", P = "IAzkAq_xs", e = {
  baseIcon: j,
  blue: w,
  cactus: B,
  color: E,
  gold: F,
  green: H,
  lg: L,
  magenta: M,
  md: R,
  moon: T,
  purple: $,
  red: D,
  sienna: G,
  sm: J,
  teal: K,
  xl: O,
  xs: P
}, Z = h(
  ({
    m: a,
    mt: c,
    mr: r,
    mb: l,
    ml: A,
    p: m,
    pt: I,
    pr: d,
    pb: _,
    pl: g,
    icon: o,
    description: s,
    color: n,
    size: u = "md",
    className: k,
    ...q
  }, z) => {
    const [i, p] = v(""), f = b(
      {
        [e.baseIcon]: !0,
        [e[u]]: !0,
        ...n ? { [e[n]]: !0, [e.color]: !0 } : void 0,
        ...C({ m: a, mt: c, mr: r, mb: l, ml: A, p: m, pt: I, pr: d, pb: _, pl: g })
      },
      k
    );
    return S(() => {
      N(o).then((t = "") => {
        p(t);
      }).catch((t) => {
        console.error(`Failed to load icon "${o}":`, t);
      });
    }, [o]), /* @__PURE__ */ x(
      "span",
      {
        ...y(q, ["className", "style", "slot", "children"]),
        ref: z,
        "data-icon-name": o,
        className: f,
        role: s ? "img" : "presentation",
        "aria-label": s,
        "aria-hidden": s ? void 0 : "true",
        dangerouslySetInnerHTML: { __html: i }
      }
    );
  }
);
export {
  Z as BaseIcon
};
//# sourceMappingURL=index.js.map
